import React, { createContext, useContext, useState } from 'react';
import { calculateModuleTotal } from '../data/pricing';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const addPackage = (pkg) => {
    setSelectedPackage(pkg);
    if (!pkg?.isCustom) {
      setSelectedAddons([]);
    }
    if (pkg) {
      setIsCartOpen(true);
    }
  };

  const addAddon = (addon) => {
    setSelectedAddons((current) => {
      const exists = current.find((item) => item.id === addon.id);
      if (!exists) {
        return [...current, { ...addon, quantity: addon.quantity || 1 }];
      }
      if (!addon.allowMultiple) {
        return current;
      }
      return current.map((item) =>
        item.id === addon.id
          ? { ...item, quantity: (item.quantity || 1) + 1 }
          : item
      );
    });
  };

  const updateAddonQuantity = (addonId, quantity) => {
    setSelectedAddons((current) => {
      if (quantity <= 0) {
        return current.filter((item) => item.id !== addonId);
      }
      return current.map((item) =>
        item.id === addonId ? { ...item, quantity } : item
      );
    });
  };

  const removeAddon = (addonId) => {
    setSelectedAddons((current) =>
      current.filter((item) => item.id !== addonId)
    );
  };

  const addPlan = (plan) => {
    setSelectedPlan(plan);
  };

  const clearCart = () => {
    setSelectedPackage(null);
    setSelectedAddons([]);
    setSelectedPlan(null);
  };

  const getOneTimeTotal = () => {
    let total = 0;
    if (selectedPackage) total += selectedPackage.price;
    total += calculateModuleTotal(selectedAddons);
    return total;
  };

  const getMonthlyTotal = () => {
    return selectedPlan ? selectedPlan.price : 0;
  };

  const hasItems = () => {
    return selectedPackage || selectedAddons.length > 0 || selectedPlan;
  };

  return (
    <CartContext.Provider
      value={{
        selectedPackage,
        selectedAddons,
        selectedPlan,
        isCartOpen,
        setIsCartOpen,
        addPackage,
        addAddon,
        updateAddonQuantity,
        removeAddon,
        addPlan,
        clearCart,
        getOneTimeTotal,
        getMonthlyTotal,
        hasItems,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};
